'use client'

import { useAtom } from 'jotai'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { forceShowTrackingConsentBannerAtom } from '@/src/stores/tracking/atoms'
import { saveTrackingConsent } from '@/src/stores/tracking-consent'
import { Button } from '../ui/button'

interface TrackingConsentBannerProps {
  trackingConsent?: boolean
}

export function TrackingConsentBanner({
  trackingConsent,
}: TrackingConsentBannerProps) {
  const [forceShowTrackingConsentBanner, setForceShowTrackingConsentBanner] =
    useAtom(forceShowTrackingConsentBannerAtom)
  const router = useRouter()

  const handleAction = () => {
    setForceShowTrackingConsentBanner(false)
    fetch('/api/users/update-cookies-consent')
    router.refresh()
  }
  const handleAccept = () => {
    saveTrackingConsent(true)
    handleAction()
  }

  const handleReject = () => {
    saveTrackingConsent(false)
    handleAction()
  }
  if (!forceShowTrackingConsentBanner && trackingConsent !== undefined)
    return null

  return (
    <div className='fixed z-50 bottom-5 sm:bottom-8 left-0 right-0 flex items-center justify-center pl-20 pr-4 sm:p-0 px-page-gutter pointer-events-none'>
      <div className='flex flex-col sm:flex-row items-center py-4 px-5 bg-surface2-100 rounded-[20px] gap-3 sm:gap-8 pointer-events-auto'>
        <p className='text-primary text-sm leading-6'>
          We use essential cookies to improve your experience.{' '}
          <Link href='/privacy-policy' className='link'>
            Learn more
          </Link>
        </p>
        <div className='flex items-center gap-8 self-end sm:self-center'>
          <Button type='button' size='sm' onClick={handleAccept}>
            Accept
          </Button>
          <Button type='button' size='sm' onClick={handleReject}>
            Reject
          </Button>
        </div>
      </div>
    </div>
  )
}
